import config from 'config';
import { AxiosResponse } from 'axios';
import { ListPayload, SuccessResponse } from 'core/http/response';
import axiosClient from 'config/axios';
import {
    AdditionalCharge,
    CreateChargePayload,
    InvoiceConfig,
    ListAdditionalChargesParams,
    UpdateCustomerAdditionalChargePayload,
    UpdateInvoiceConfigEmailTempaltePayload as UpdateInvoiceConfigEmailTemplatePayload,
    UpdateInvoiceConfigGeneralSettingsPayload,
    UpdateInvoiceConfigInvoiceTemplatePayload,
} from './types';

export const getInvoiceConfig = async (): Promise<InvoiceConfig> => {
    const response: AxiosResponse<SuccessResponse<InvoiceConfig>> = await axiosClient.get(
        `${config.declarationsUrl}/invoice-config`
    );
    return response.data.payload;
};

export const updateInvoiceConfigGeneralSettings = async (
    payload: UpdateInvoiceConfigGeneralSettingsPayload
): Promise<InvoiceConfig> => {
    const response: AxiosResponse<SuccessResponse<InvoiceConfig>> = await axiosClient.patch(
        `${config.declarationsUrl}/invoice-config/general-settings`,
        payload
    );
    return response.data.payload;
};
export const updateInvoiceConfigInvoiceTemplate = async (
    payload: UpdateInvoiceConfigInvoiceTemplatePayload
): Promise<InvoiceConfig> => {
    const response: AxiosResponse<SuccessResponse<InvoiceConfig>> = await axiosClient.patch(
        `${config.declarationsUrl}/invoice-config/invoice-template`,
        payload
    );
    return response.data.payload;
};
export const updateInvoiceConfigEmailTemplate = async (
    payload: UpdateInvoiceConfigEmailTemplatePayload
): Promise<InvoiceConfig> => {
    const response: AxiosResponse<SuccessResponse<InvoiceConfig>> = await axiosClient.patch(
        `${config.declarationsUrl}/invoice-config/email-template`,
        payload
    );
    return response.data.payload;
};

export const createAdditionalCharge = async (payload: CreateChargePayload): Promise<AdditionalCharge> => {
    const response: AxiosResponse<SuccessResponse<AdditionalCharge>> = await axiosClient.post(
        `${config.cmsUrl}/additional-charges`,
        payload
    );
    return response.data.payload;
};

export const editAdditionalCharge = async (
    chargeId: string,
    payload: Partial<CreateChargePayload>
): Promise<AdditionalCharge> => {
    const response: AxiosResponse<SuccessResponse<AdditionalCharge>> = await axiosClient.patch(
        `${config.cmsUrl}/additional-charges/${chargeId}`,
        payload
    );
    return response.data.payload;
};

export const archiveAdditionalCharge = async (chargeId: string): Promise<AdditionalCharge> => {
    const response: AxiosResponse<SuccessResponse<AdditionalCharge>> = await axiosClient.put(
        `${config.cmsUrl}/additional-charges/archive/${chargeId}`
    );
    return response.data.payload;
};

export const unarchiveAdditionalCharge = async (chargeId: string): Promise<AdditionalCharge> => {
    const response: AxiosResponse<SuccessResponse<AdditionalCharge>> = await axiosClient.put(
        `${config.cmsUrl}/additional-charges/unarchive/${chargeId}`
    );
    return response.data.payload;
};

export const getCustomersUsingAdditionalCharge = async (additionalChargeId: string): Promise<string[]> => {
    const response: AxiosResponse<SuccessResponse<string[]>> = await axiosClient.get(
        `${config.cmsUrl}/additional-charges/${additionalChargeId}/customers-usage`
    );
    return response.data.payload;
};

export const listAdditionalCharges = async (
    params?: ListAdditionalChargesParams
): Promise<ListPayload<AdditionalCharge>> => {
    const response: AxiosResponse<SuccessResponse<ListPayload<AdditionalCharge>>> = await axiosClient.get(
        `${config.cmsUrl}/additional-charges`,
        { params }
    );
    return response.data.payload;
};

export const listCustomerAdditionalCharges = async (
    customerId: string,
    params?: ListAdditionalChargesParams
): Promise<ListPayload<AdditionalCharge>> => {
    const response: AxiosResponse<SuccessResponse<ListPayload<AdditionalCharge>>> = await axiosClient.get(
        `${config.cmsUrl}/additional-charges/list/${customerId}`,
        { params }
    );
    return response.data.payload;
};

export const addCustomerAdditionalCharge = async (
    customerId: string,
    additionalChargeId: string
): Promise<AdditionalCharge> => {
    const response: AxiosResponse<SuccessResponse<AdditionalCharge>> = await axiosClient.post(
        `${config.cmsUrl}/additional-charges/${customerId}`,
        {},
        {
            params: {
                customerId,
                additionalChargeId,
            },
        }
    );
    return response.data.payload;
};

export const updateCustomerAdditionalCharge = async (
    customerId: string,
    additionalChargeId: string,
    payload: UpdateCustomerAdditionalChargePayload
): Promise<AdditionalCharge> => {
    const response: AxiosResponse<SuccessResponse<AdditionalCharge>> = await axiosClient.put(
        `${config.cmsUrl}/additional-charges/${customerId}`,
        payload,
        {
            params: {
                customerId,
                additionalChargeId,
            },
        }
    );
    return response.data.payload;
};

export const archiveCustomerAdditionalCharge = async (
    customerId: string,
    additionalChargeId: string
): Promise<AdditionalCharge> => {
    const response: AxiosResponse<SuccessResponse<AdditionalCharge>> = await axiosClient.put(
        `${config.cmsUrl}/additional-charges/${customerId}/archive/${additionalChargeId}`,
        {},
        {
            params: {
                customerId,
                additionalChargeId,
            },
        }
    );
    return response.data.payload;
};

export const unarchiveCustomerAdditionalCharge = async (
    customerId: string,
    additionalChargeId: string
): Promise<AdditionalCharge> => {
    const response: AxiosResponse<SuccessResponse<AdditionalCharge>> = await axiosClient.put(
        `${config.cmsUrl}/additional-charges/${customerId}/unarchive/${additionalChargeId}`,
        {},
        {
            params: {
                customerId,
                additionalChargeId,
            },
        }
    );
    return response.data.payload;
};
